import { CustomTextFieldWithPercentage } from "@/dentlab/src/forms/form-input-components/custom-input-components/custom-text-field-with-percentage.component";
import { useJobStore } from "@/dentlab/src/store/Jobs";

export const JobInfoTpVariation: React.FC<{
	inputHeight?: number;
	validationError?: string | null;
}> = ({ inputHeight, validationError }) => {
	const { job, updateJobFields, updateJobItems } = useJobStore((state) => ({
		job: state.job,
		updateJobFields: state.updateJobFields,
		updateJobItems: state.updateJobItems,
	}));

	const handleChange = async (value: string) => {
		const numberValue = value === "" ? 0 : parseFloat(value);
		if (!job?.id) {
			return;
		}
		updateJobFields({ tp_variation: numberValue });
		await updateJobItems(job.id as number, undefined, numberValue);
	};
	return (
		<CustomTextFieldWithPercentage
			label="TP-Variation (+/-)"
			name="tp_variation"
			value={job?.tp_variation === 0 ? "" : (job?.tp_variation ?? "")}
			onChange={(e) => handleChange(e.target.value)}
			fullWidth
			inputHeight={inputHeight}
			validationError={validationError}
		/>
	);
};
